/**
 * Primary front-end script.
 *
 * Primary JavaScript file. Any includes or anything imported should
 * be filtered through this file and eventually saved back into the
 * `/dist/js/app.js` file.
 *
 * @package   Codeable
 * @author    Chris Almighty, John Leskas, Panagiotis Synetos, Spyros Vlachopoulos <panagiotis.synetos@gmail.com>
 * @copyright 2019 Chris Almighty, John Leskas, Panagiotis Synetos, Spyros Vlachopoulos
 * @license   https://www.gnu.org/licenses/gpl-2.0.html GPL-2.0-or-later
 * @link      https://codeable.io
 */

/**
 * Import 3rd party libraries
 */
import Cookies from 'js-cookie'


/**
 * A simple immediately-invoked function expression to kick-start
 * things and encapsulate our code.
 *
 * @since  1.0.0
 * @access public
 * @return void
 */
(function () {
	let couponCodeQueryParam = getParameterByName('coupon_code');

	// Check if there is a coupon code as a URL Query Param and pass that value into a browser-cookie
	if (couponCodeQueryParam) {
		const url = removeHttpAndWww(theme_args.homeUrl);
		Cookies.set('coupon_code', couponCodeQueryParam, {domain: '.' + url, expires: 365})
	}

	// Check if there is a referrer global variable in the document and pass that value as a browser-cookie
	if (document.referrer) {
		Cookies.set('referrer', document.referrer.split('/')[2], 365);
	}

	fireAndSave();


	/**
	 * Get the name (value) of the parameter used in the URL as Query Param
	 *
	 * @since  1.0.0
	 * @access public
	 * @return void
	 */
	function getParameterByName(name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		let results = regex.exec(location.search);

		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

	/**
	 * Remove HTTP and WWW from the url
	 * @param url URL to be cleaned
	 * @returns {*}
	 */
	function removeHttpAndWww(url) {
		url = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
		return url;
	}

	/**
	 * Check on whether a ref Query param exists and is valid
	 * and it adds a browser-cookie and runs an AJAX request to the api.codeable.io
	 *
	 * @since  1.0.0
	 * @access public
	 * @return void
	 */
	function fireAndSave() {
		let refQueryParam = null; // Set this one to `null`

		/*
		 * Check if there is a `ref` URL param
		 * and if it is empty, then return and don't run any of the code below.
		 */
		if (getParameterByName('ref') === '') {
			return;
		}

		refQueryParam = getParameterByName('ref'); // Set variable based on URL Param


		/*
		 * Make a POST request using ES6 fetch API using the referoo code as a key named `shortcode` inside formData
		 */
		// https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
		let formData = new FormData(); // Build new Form data object
		formData.append('shortcode', refQueryParam); // Pass the ref URL Param as a key inside form data

		if (getParameterByName('prod') !== '') {
			formData.append('prod', getParameterByName('prod'))
		}

		if (getParameterByName('cust') !== '') {
			formData.append('cust', getParameterByName('cust'))
		}

		if (getParameterByName('cust_id') !== '') {
			formData.append('cust_id', getParameterByName('cust_id'))
		}

		// api.staging.codeable.io
		let apiEndPoint;
		if (window.location.hostname === 'www.codeable.io') {
			apiEndPoint = 'https://api.codeable.io/referoo/visits';
		} else {
			apiEndPoint = 'https://api.staging.codeable.io/referoo/visits';
		}


		fetch(apiEndPoint, {
			method: 'post',
			credentials: 'include',
			body: formData
		}).then(response => {
			if (response.ok) {
				const url = removeHttpAndWww(theme_args.homeUrl);
				Cookies.set('referoo_referred', true,  {domain: '.' + url, expires: 365});
				return Promise.resolve(response);


			} else {
				return Promise.reject(new Error('Failed to load'));
			}
		})
			.then(response => response.json()) // parse response as JSON
			.then(data => {
				// success
				console.log('Data: ', data);
			})
			.catch(function (error) {
				console.log(`Error: ${error.message}`);
			});
	}
})();
